module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/cloud-sun-398b6948859d7ede5b4b678b546e7da2.svg";